import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-settingsbox',
    templateUrl: './settingsbox.component.html',
    styleUrls: ['./settingsbox.component.css'],
    standalone: true,
    imports: [CommonModule, RouterLink, MatButtonModule]
})

export class SettingsBoxComponent {

  constructor(public authService: AuthService) { }

}
